// PR-11.0 — pure date/time formatter, extracted from bookingLeagueSync
// so vitest can import it without pulling in the supabase client (which
// auto-loads a session in the test env and triggers an unhandled
// rejection).

/**
 * Split a JS Date into postgres `date` + `time without time zone`
 * strings, using the LOCAL timezone (not UTC). League matches are stored
 * as user-intended local time (e.g., "May 5 14:00 Stockholm"), not UTC,
 * so the conversion must respect local time.
 */
export function splitTimestampLocal(date: Date): {
  dateString: string; // YYYY-MM-DD
  timeString: string; // HH:MM:SS
} {
  const yyyy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const hh = String(date.getHours()).padStart(2, "0");
  const mi = String(date.getMinutes()).padStart(2, "0");
  const ss = String(date.getSeconds()).padStart(2, "0");
  return {
    dateString: `${yyyy}-${mm}-${dd}`,
    timeString: `${hh}:${mi}:${ss}`,
  };
}
